import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { createRef } from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl-next';
import { Popup } from '@atlaskit/editor-common/ui';
import CollapseIcon from '@atlaskit/icon/glyph/editor/collapse';
import ExpandIcon from '@atlaskit/icon/glyph/editor/expand';
import commonMessages from '@atlaskit/editor-common/messages';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { toggleTableLayoutWithAnalytics } from '../../commands-with-analytics';
import { TableCssClassName as ClassName } from '../../types';
import { findDomRefAtPos } from 'prosemirror-utils';
var addPopupOffset = function addPopupOffset(pos) {
  return _objectSpread(_objectSpread({}, pos), {}, {
    // add 12 pixels to align y position with
    //the columns controls
    top: pos.top ? pos.top + 12 : undefined
  });
};
var getMessage = function getMessage(layout) {
  switch (layout) {
    case 'default':
      return commonMessages.layoutWide;
    case 'wide':
      return commonMessages.layoutFullWidth;
    default:
      return commonMessages.layoutFixedWidth;
  }
};
var LayoutButton = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutButton, _React$Component);
  var _super = _createSuper(LayoutButton);
  function LayoutButton() {
    var _this;
    _classCallCheck(this, LayoutButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "stickyButtonRef", /*#__PURE__*/createRef());
    _defineProperty(_assertThisInitialized(_this), "resizeObserver", new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var resizeButton = _this.stickyButtonRef.current;
        var tableWrapper = _this.props.targetRef;
        if (resizeButton && tableWrapper) {
          var clientRect = tableWrapper.getBoundingClientRect();
          resizeButton.style.left = "".concat(clientRect.right, "px");
        }
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$props$editorVie = _this.props.editorView,
        state = _this$props$editorVie.state,
        dispatch = _this$props$editorVie.dispatch;
      toggleTableLayoutWithAnalytics(_this.props.editorAnalyticsAPI)(state, dispatch);
    });
    return _this;
  }
  _createClass(LayoutButton, [{
    key: "getTitle",
    value: function getTitle() {
      var _this$props = this.props,
        formatMessage = _this$props.intl.formatMessage,
        _this$props$layout = _this$props.layout,
        layout = _this$props$layout === void 0 ? 'default' : _this$props$layout;
      return formatMessage(getMessage(layout));
    }
  }, {
    key: "toolbarButton",
    value: function toolbarButton() {
      var _this$props2 = this.props,
        isResizing = _this$props2.isResizing,
        _this$props2$layout = _this$props2.layout,
        layout = _this$props2$layout === void 0 ? 'default' : _this$props2$layout;
      var title = this.getTitle();
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(ClassName.LAYOUT_BUTTON, _defineProperty({}, ClassName.IS_RESIZING, isResizing))
      }, /*#__PURE__*/React.createElement(ToolbarButton, {
        title: title,
        onClick: this.handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/React.createElement(CollapseIcon, {
          label: title
        }) : /*#__PURE__*/React.createElement(ExpandIcon, {
          label: title
        })
      }));
    }
  }, {
    key: "getStickyTargetRef",
    value: function getStickyTargetRef(pos) {
      var editorView = this.props.editorView;
      var domAtPos = editorView.domAtPos.bind(editorView);
      var node = findDomRefAtPos(pos, domAtPos);
      return node.dataset['headerRow'] && node.classList.contains('sticky') ? node : null;
    }
  }, {
    key: "renderSticky",
    value: function renderSticky(button, targetRef, tableRef) {
      var title = this.getTitle();
      if (!(targetRef instanceof HTMLElement) || !(tableRef instanceof HTMLElement)) {
        return null;
      }
      var pos = targetRef.getBoundingClientRect();
      var tablePos = tableRef.getBoundingClientRect();
      return /*#__PURE__*/React.createElement("div", {
        ref: this.stickyButtonRef,
        "aria-label": title,
        style: {
          position: 'fixed',
          top: pos.top + 22,
          left: tablePos.right
        }
      }, button);
    }
  }, {
    key: "renderPopup",
    value: function renderPopup(button) {
      var _this$props3 = this.props,
        mountPoint = _this$props3.mountPoint,
        boundariesElement = _this$props3.boundariesElement,
        scrollableElement = _this$props3.scrollableElement,
        targetRef = _this$props3.targetRef;
      if (!targetRef) {
        return null;
      }
      var title = this.getTitle();
      return /*#__PURE__*/React.createElement(Popup, {
        ariaLabel: title,
        target: targetRef,
        alignY: "start",
        alignX: "end",
        onPositionCalculated: addPopupOffset,
        stick: true,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        forcePlacement: true
      }, button);
    }
  }, {
    key: "render",
    value: function render() {
      var stickyHeader = this.props.stickyHeader;
      var button = this.toolbarButton();
      var stickyTargetRef = stickyHeader && stickyHeader.sticky && stickyHeader.pos ? this.getStickyTargetRef(stickyHeader.pos) : null;
      if (stickyTargetRef && this.props.targetRef) {
        return this.renderSticky(button, stickyTargetRef, this.props.targetRef);
      } else {
        return this.renderPopup(button);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var dom = this.props.editorView.dom;
      var scrollPanel = dom.closest('.fabric-editor-popup-scroll-parent');
      if (scrollPanel instanceof HTMLElement) {
        this.resizeObserver.observe(scrollPanel);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var dom = this.props.editorView.dom;
      var scrollPanel = dom.closest('.fabric-editor-popup-scroll-parent');
      if (scrollPanel instanceof HTMLElement) {
        this.resizeObserver.unobserve(scrollPanel);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props4 = this.props,
        targetRef = _this$props4.targetRef,
        layout = _this$props4.layout,
        isResizing = _this$props4.isResizing,
        stickyHeader = _this$props4.stickyHeader;
      return stickyHeader !== nextProps.stickyHeader || targetRef !== nextProps.targetRef || layout !== nextProps.layout || isResizing !== nextProps.isResizing;
    }
  }]);
  return LayoutButton;
}(React.Component);
_defineProperty(LayoutButton, "displayName", 'LayoutButton');
export default injectIntl(LayoutButton);